module.exports = __webpack_public_path__ + "img/hydroponic.0f0d1e44.png";